module.exports = __webpack_public_path__ + "img/view.47a665d5.png";